import { InputProps } from '@/types/form/input-props';
import { AnyFieldApi, AnyFormApi } from '@tanstack/react-form';

export const fieldToInputProps = <TValue, TName extends string = string>(
  field: AnyFieldApi,
  label: ((name: TName) => string) | string,
): InputProps<TValue> => ({
  label: typeof label === 'function' ? label(field.name as any) : label,
  name: field.name as TName,
  value: field.state.value as TValue,
  errors: field.state.meta.errors.map((e) => (e?.message ? e.message : e)) as string[],
  onChange: (value: TValue) => field.handleChange(value),
  onBlur: field.handleBlur,
});

export const toFormProps = (form: AnyFormApi): React.FormHTMLAttributes<HTMLFormElement> => ({
  onReset: (e) => {
    e.stopPropagation();
    e.preventDefault();
    form.reset();
  },
  onSubmit: (e) => {
    e.stopPropagation();
    e.preventDefault();
    form.handleSubmit(e);
  },
});
